export default __webpack_public_path__ + "static/media/INEX.2f19cbb7.png";